import { render, staticRenderFns } from "./RpmLayout.vue?vue&type=template&id=31b1b866&scoped=true&"
import script from "./RpmLayout.vue?vue&type=script&lang=js&"
export * from "./RpmLayout.vue?vue&type=script&lang=js&"
import style0 from "./RpmLayout.vue?vue&type=style&index=0&id=31b1b866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1b866",
  null
  
)

export default component.exports